import BarcodeSettingsPage from '@/components/pages/inventory/settings/barcode/page'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/backend-settings/barcode')({
  component: BarcodeSettingsPage,
})
